import React, { useState } from 'react';
import Field from './Field';
import InputTextField from './InputTextField';
import ActionButton from '../Common/ActionButton';
import { querySendBarcodeEmail } from '../../Queries';
import './EmailBarcodeField.scss';

function EmailBarcodeField({ parkerId, parkerEmail }) {
    const [emailAddress, setEmailAddress] = useState(parkerEmail);
    const [showInput, setShowInput] = useState(false);
    const [successMode, setSuccessMode] = useState(false);
    const [queryInProgress, setQueryInProgress] = useState(false);
    const [error, setError] = useState(false);

    function onEmailInputChange(value) {
        setEmailAddress(value);
    }

    function onEmailBarcodeClick() {
        setShowInput(true);
    }

    async function onSendClick() {
        setQueryInProgress(true);

        const { errors } = await querySendBarcodeEmail({ parkerId, emailAddress });

        if (errors) {
            console.log(errors);
            setError(true);
        } else {
            setSuccessMode(true);
        }

        setQueryInProgress(false);
    }

    function onCancelClick() {
        setEmailAddress(parkerEmail);
        setShowInput(false);
        setSuccessMode(false);
        setQueryInProgress(false);
        setError(false);
    }

    const message = (
        queryInProgress ? ''
        : error ? 'An error occurred sending the email'
        : successMode ? 'Email sent'
        : `Enter an email address to send the parker's barcode`
    );

    return (
        <>
            {!showInput ?
                <ActionButton
                    id='email-barcode-button'
                    label='Email Barcode'
                    onClick={onEmailBarcodeClick}
                />
            :
                <div className='email-barcode'>
                    <span id='email-barcode-message'>
                        {message}
                    </span>
                    {!successMode ?
                        <div className='email-barcode-fields'>
                            <Field
                                label='Email'
                                layout='columns'
                            >
                                <InputTextField
                                    inputId='email-input'
                                    value={emailAddress}
                                    onChange={onEmailInputChange}
                                    editMode={true}
                                />
                            </Field>
                            <ActionButton
                                id='send-button'
                                label='Send'
                                inProgressState={queryInProgress}
                                onClick={onSendClick}
                            />
                            <button
                                type='button'
                                id='cancel-button'
                                className='parkchirp--button-as-link'
                                onClick={onCancelClick}
                            >
                                Cancel
                            </button>
                        </div>
                    :
                        <div>
                            <ActionButton
                                id='ok-button'
                                label='OK'
                                onClick={onCancelClick}
                            />
                        </div>
                    }
                </div>
            }
        </>
    );
}

export default EmailBarcodeField;
